<section>
  <!-- Page header -->
  <div class="blogs-header">
    <div class="container">
      <span class="blog-label">{{ 'blogs.label' | translate }}</span>
      <h2>{{ 'blogs.title' | translate }}</h2>
    </div>
  </div>

  <div class="container">
    <div class="mx-md-5">
      <div class="row">
        <div *ngFor="let item of blogs_arr" class="col-12 col-md-4 mb-4">
          <div class="cardStyle" (click)="blogDetails(item.id)">
            <div class="imageBlog">
              <img
                [src]="item.media[0].image_url"
                [alt]="item.title"
                (error)="item.media[0].image_url = 'assets/images/rk.jpeg'"
              />
            </div>
            <div class="info">
              <p>{{ item.title }}</p>
              <p>{{ item.joined_date | date:'mediumDate' }}</p>
              <p class="readMore">
                <a>{{ 'blogs.read_more' | translate }}</a>
                <i class="ti-arrow-right"></i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
